import { has, isArray, each } from 'lodash'
import { notify } from 'utils'

/**
 * Before each route we determine if the user has the necessary permissions to access the page
 * they are trying to get to.
 */
export default (to, from, next, user) => {
  const is = (roles) => {
    if (!isArray(roles)) {
      roles = roles.split(',')
    }

    let isRole = false

    each(roles, (role) => {
      if (user.role === role) {
        isRole = true
      }
    })

    return isRole
  }

  if (has(to.meta, 'permissions')) {
    if (typeof to.meta.permissions === 'function') {
      if (!to.meta.permissions(user, is, to, from)) {
        notify.error('You do not have the necessary permission to perform this action.')

        next({ name: 'dashboard', replace: true, query: { src: 'permission' } })

        return
      }
    } else if (!is(to.meta.permissions)) {
      notify.error('You do not have the necessary permission to perform this action.')

      next({ name: 'dashboard', replace: true, query: { src: 'permission' } })

      return
    }
  }

  next()
}
